import { connect } from 'react-redux';
import { selectTicket, setChatMacroRecommendationsEnabled } from '../../actions/index';
import { setSelectedTask } from '../../actions/tools/OrdersSearchActions';
import QueueComponent from '../../components/inboxPanel/Queue/Queue';
import { activateHistoricalTicket } from '../../actions/tools/ToolActions';
import {
  extractTicketsFromState,
  extractSelectedHistoricalTicketIdFromState,
  extractSelectedTicketIdFromState,
  extractNonHistoricalTicketIdFromState,
  isSelectedTicketReviewTicket,
  extractDisplayingHistoricalConversationFromState,
  isAPartnerProtector,
  getHasSearchedAllTab,
} from '../../extractFromState';
import { asyncHydrateExpertsForQueueComponent } from 'actions/QueueComponentActions';

const mapStateToProps = (state) => ({
  isAdmin: state.user.isAdmin,
  tickets: extractTicketsFromState(state),
  inboxTab: state.ui.messages.selectedInboxTab,
  allFilter: state.selectedTicketStatus,
  loading: state.ui.loading,
  idsToExperts: state.experts.idsToExperts,
  isSelectedHistoricalTicket: !!extractSelectedHistoricalTicketIdFromState(state),
  selectedTicketId: extractSelectedTicketIdFromState(state),
  selectedNonHistoricalTicketId: extractNonHistoricalTicketIdFromState(state),
  displayingHistoricalConversations: extractDisplayingHistoricalConversationFromState(state),
  reviewTicketSelected: isSelectedTicketReviewTicket(state),
  isAPartnerProtector: isAPartnerProtector(state),
  hasSearchedAllTab: getHasSearchedAllTab(state),
});

const mapDispatchToProps = (dispatch) => {
  return {
    onShowMessageDetails: (ticketId, messageCategory) => {
      dispatch({
        type: 'SELECTED_TOOL',
        name: 'ACTIONS',
      });
      dispatch(selectTicket(ticketId, messageCategory));
      if (messageCategory === 'assigned') {
        dispatch(setSelectedTask(null));
      }
      dispatch(setChatMacroRecommendationsEnabled(true));
    },
    activateHistoricalTicket() {
      dispatch(activateHistoricalTicket());
    },
    asyncHydrateExperts() {
      dispatch(asyncHydrateExpertsForQueueComponent());
    },
  };
};

const QueueContainer = connect(mapStateToProps, mapDispatchToProps)(QueueComponent);

export default QueueContainer;
